 import tippy from 'tippy.js';
// var $ = require('jquery');
// $(document).ready(function(){
//     setTimeout(function(){
//         $('.copyclipboard .float-end').tooltip({
//             trigger : 'click',
//   position:'bottom'
//         });
//      }, 5000);
   
//     });

// $.noConflict();
// document.addEventListener('DOMContentLoaded', function() {
//     tippy('.copyclipboard .float-end', {
//         trigger: 'click',
//         placement: 'top',
//     });
// });

document.addEventListener('DOMContentLoaded', function() {
    tippy('.copyclipboard .float-end', {
        trigger: 'click',
        placement: 'top', // 'position' is 'placement' in tippy.js
    });
});